window.addEventListener("load", function () {
    let logo = document.getElementById("site-logo");
    let container = document.querySelector(".display-screen");
    let clickCount = 0;
    let clickTimeout = null;

    function adjustHeight() {
        setTimeout(() => {
            if (document.fullscreenElement) {
                container.style.height = window.innerHeight + "px";
            } else {
                container.style.height = "100vh";
            }
        }, 500);
    }

    // Triple-click event for toggling fullscreen
    logo.addEventListener("click", function () {
        clickCount++;

        if (clickCount === 3) {
            clickCount = 0; // Reset click count

            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen()
                    .then(adjustHeight)
                    .catch(err => console.error("Fullscreen error:", err));
            } else {
                document.exitFullscreen()
                    .then(adjustHeight)
                    .catch(err => console.error("Exit fullscreen error:", err));
            }
        }

        // Reset click count if no triple-click within 500ms
        if (clickTimeout) clearTimeout(clickTimeout);
        clickTimeout = setTimeout(() => {
            clickCount = 0;
        }, 500);
    });

    // Listen for fullscreen change events to adjust height dynamically
    document.addEventListener("fullscreenchange", adjustHeight);
});
